import { useCallback } from 'react';
import { isCancelled, useModalPromise } from '@cp/shared/modal';
import {
  PERSONAL_QUALITIES_ANSWERS_MODAL,
  PERSONAL_QUALITIES_MULTI_ANALYSIS_MODAL,
  PERSONAL_QUALITIES_PROMPT_EDIT_MODAL,
} from '../lib/modals';

const ignoreCancelled = (error: unknown) => {
  if (!isCancelled(error)) {
    throw error;
  }
};

export const usePersonalQualitiesModals = () => {
  const openAnswers = useModalPromise(PERSONAL_QUALITIES_ANSWERS_MODAL);
  const openPromptEdit = useModalPromise(PERSONAL_QUALITIES_PROMPT_EDIT_MODAL);
  const openMultiAnalysis = useModalPromise(PERSONAL_QUALITIES_MULTI_ANALYSIS_MODAL);

  const openAnswersModal = useCallback((...args: Parameters<typeof openAnswers>) => openAnswers(...args).catch(ignoreCancelled), [openAnswers]);
  const openPromptEditModal = useCallback(
    (...args: Parameters<typeof openPromptEdit>) => openPromptEdit(...args).catch(ignoreCancelled),
    [openPromptEdit],
  );
  const openMultiAnalysisModal = useCallback(
    (...args: Parameters<typeof openMultiAnalysis>) => openMultiAnalysis(...args).catch(ignoreCancelled),
    [openMultiAnalysis],
  );

  return { openAnswersModal, openPromptEditModal, openMultiAnalysisModal };
};
